import { createContext, useContext, useState, useEffect } from 'react';
import { API_URL } from '../config';

const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('token');
        const storedUser = localStorage.getItem('user');
        if (token && storedUser) {
            setUser(JSON.parse(storedUser));
        }
        setLoading(false);
    }, []);

    const login = async (email, password) => {
        try {
            const res = await fetch(`${API_URL}/api/auth/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password })
            });

            let data;
            const contentType = res.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                data = await res.json();
            } else {
                // If not JSON (e.g. 503 HTML page), read as text but treat as error
                const text = await res.text();
                // We don't want to show HTML in the error message, so just use statusText
                throw new Error(res.statusText + (res.status === 503 ? " - Server Unavailable" : ""));
            }

            if (!res.ok) throw new Error(data.error || 'Credenciales incorrectas. Por favor intente nuevamente.');

            localStorage.setItem('token', data.token);
            localStorage.setItem('user', JSON.stringify(data.user));
            setUser(data.user);
            return {
                success: true,
                user: data.user,
                requiresOpenCaja: data.requiresOpenCaja === true,
                availableCajas: data.availableCajas || [],
                openCajaSession: data.openCajaSession || null
            };
        } catch (err) {
            console.error("Login failed:", err);
            return { success: false, error: err.message };
        }
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
